import { Grid } from '@mui/material';
import { FC } from 'react';
import { HeaderFields } from '../../../../components/HeaderFields';
import { CampaignFields } from './CampaignFields';
import { useStyles } from './styles';

export const Generalities: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.grid}>
      <Grid item className={classes.grid}>
        <CampaignFields />
      </Grid>
      <Grid item className={classes.grid}>
        <HeaderFields />
      </Grid>
    </div>
  );
};
